import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator,
} from 'react-native';

import Clipboard from "@react-native-community/clipboard"

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import FormikInput from '../../components/form/FormikInput';
import FormikSelectList from '../../components/form/FormikSelectList';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
import OTPInputView from '@twotalltotems/react-native-otp-input';
import GenericHeader from '../../components/headers/GenericHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import http from '../../utils/http';
import { formatCurrency } from '../../utils/money';
// import SmsRetriever from 'react-native-sms-retriever';

const analytics = new AnalyticsService

function SendStartScreen() {
    const navigation = useNavigation()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [isLoading, setLoading] = React.useState(false)
    const [banks, setBanks] = React.useState(null)

    const [confirmBoxOpen, setConfirmBoxOpen] = React.useState(false)
    const hideConfirmModal = () => {
        setConfirmBoxOpen(false)
    }

    const formSchema = Yup.object().shape({
        account: Yup.string()
            .matches(/^\d{10}$/, 'Enter a valid account number')
            .required('Account number is required'),
        amount: Yup.string()
            .matches(/\d$/, 'Enter a valid amount')
            .test('match', `You can only transfer ${formatCurrency(1000)} and above`, amount => {
                return parseInt(amount.replace(/[^0-9]+/g, '')) > 999
            })
            .required('Enter an amount'),
        bank: Yup.string().required('Select a bank')
    });

    const getAccountDetails = (values, actions) => {
        const form = new FormData()
        form.append('model', 'buyer')
        form.append('mobile', buyer.phone)
        form.append('account_number', values?.account)
        form.append('account_bank', values?.bank)

        http.post('spend/eyowo_verify_bank', form, token)
            .then(res => {
                // {
                //     "code": 200,
                //     "data": {
                //         "data": {
                //             "accountName": "LATA ISAH JAMES",
                //             "accountNumber": "0027646040",
                //             "bankCode": "000013"
                //         },
                //         "success": true
                //     },
                //     "message": ""
                // }
                if (res.code === 200 && res.data.success === true) {
                    actions.setSubmitting(false)
                    actions.setFieldValue('bank', '')
                    actions.resetForm()
                    let account_details = {
                        ...res.data.data, 
                        amount: values.amount,
                        bankName: banks.find(x => x.bankCode === values?.bank)?.bankName
                    }
                    // console.log({account_details})
                    navigation.navigate('WalletSendEnd', {account_details})
                } else {
                    // ToastAndroid.show(res?.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    console.warn(res)
                }
            })
            .catch(err => {
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                actions.setSubmitting(false)
                console.warn(err)
            })
    }

    const getBanks = () => {
        setLoading(true)
        let form = new FormData()
        form.append('model', 'buyer')
        form.append('mobile', buyer?.phone)
        http.post('spend/eyowo_bank_dict', form, token)
            .then(res => {
                setLoading(false)
                // console.log(res)
                if (res.code === 200) {
                    let bank_list = []
                    for (var i in res.data) {
                        bank_list.push({
                            ...res.data[i],
                            _id: res.data[i]?.bankCode,
                            name: res.data[i]?.bankName
                        })
                    }
                    setBanks(bank_list)
                }
            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {
                getBanks()
                analytics.logEvent('Viewed Wallet Acount', buyer)
                analytics.googleHelpers.setCurrentScreen('ViewedWalletAccount', 'ViewedWalletAccount')
            }
        })
        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="Send Money" />
            <ScrollView contentContainerStyle={styles.container}>
                {isLoading
                    ? <View style={{ flex: 1, justifyContent: 'center' }}>
                        <ActivityIndicator color={Colors.tintColor} size={50} />
                    </View>
                    : banks
                        ? <Formik
                            initialValues={{
                                account: '',
                                amount: `${formatCurrency(0)}`,
                                bank: '',
                            }}
                            validationSchema={formSchema}
                            onSubmit={(values, actions) => getAccountDetails(values, actions)}
                        >
                            {({ values, isSubmitting, submitForm }) => <View>
                                <View style={styles.subHeader}>
                                    <FormikInput
                                        label="Amount"
                                        fieldName="amount"
                                        placeholder="Enter amount"
                                        isCurrency
                                    />
                                </View>
                                <View style={styles.subHeader}>
                                    <FormikSelectList
                                        label="Bank"
                                        fieldName="bank"
                                        options={banks}
                                        placeholder="Select Bank"
                                    />
                                </View>
                                <View style={[
                                    styles.subHeader,
                                    {
                                        paddingBottom: 40,
                                    }
                                ]}>
                                    <FormikInput
                                        label="Account Number"
                                        fieldName="account"
                                        placeholder="0000000000"
                                    />
                                    <StyledButton
                                        label="Verify Customer"
                                        color={'default'}
                                        size="lg"
                                        style={{ marginTop: 40 }}
                                        submitting={isSubmitting}
                                        disabled={isSubmitting}
                                        action={submitForm}
                                    />
                                </View>
                            </View>}
                        </Formik>
                        : <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 16 }}>
                            <StyledIcon
                                iconName="md-alert"
                                iconColor={Colors.greyColor}
                                iconOnly
                                size={50}
                            />
                            <Text style={{ marginTop: 8 }}>Failed to load. Please try again.</Text>
                            <StyledButton
                                color="default"
                                label="Try again"
                                size="sm"
                                style={{
                                    marginTop: 24
                                }}
                                action={() => getBanks()}
                            />
                        </View>
                }
            </ScrollView>
        </>
    )
}

export default SendStartScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.shades._5,
    },
    subHeader: {
        paddingHorizontal: 16,
        paddingBottom: 16,
        paddingTop: 0,
        borderBottomColor: Colors.shades._6,
        borderBottomWidth: 1,
        borderStyle: 'solid',
        backgroundColor: Colors.whiteColor
    },
    subHeaderText: {},
    formContainer: {
        backgroundColor: Colors.whiteColor,
        paddingHorizontal: 16,
        paddingBottom: 30,
    },
    starWrapper: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 58 },
    star: { width: 24, height: 28, marginHorizontal: 4 },
})